import styled from 'styled-components'

export const Content = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['24'],
}))
